// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // -------[Production]-------
  firebase: {
    apiKey: 'AIzaSyDiXXQsUsTUv9TWicQclFcPGg6hSABZP5k',
    authDomain: 'teleflex-production.firebaseapp.com',
    projectId: 'teleflex-production',
    storageBucket: 'teleflex-production.appspot.com',
    messagingSenderId: '839075683523',
    appId: '1:839075683523:web:34b3b50b1f5c64170bd676',
    measurementId: 'G-1Y74B6T8L5'
  },

  // -------[Stage]-------
  // firebase : {
  //   apiKey: "AIzaSyB_Dq1NXc7kxvyXulNwr-RYeX7JWerfCDU",
  //   authDomain: "opera-stage.firebaseapp.com",
  //   projectId: "opera-stage",
  //   storageBucket: "opera-stage.firebasestorage.app",
  //   messagingSenderId: "928646403595",
  //   appId: "1:928646403595:web:4c41fcd7d2b407e839590e"
  // }, 

  // -------[Production]-------
  api_url: 'https://teleflex-production.azurewebsites.net/',
  // -------[stage]-------
  // api_url: 'https://teleflexbackendstage.azurewebsites.net/',
  // -------[local]-------
  // api_url: 'http://localhost:8000/',
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
